// extracted by mini-css-extract-plugin
export default {"container":"admin_container__8MKUk","congratsContainer":"admin_congratsContainer__gqhpo","cardProduct":"admin_cardProduct__qDDWG"};